import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
//import { HttpClient, HttpHeaders, HttpParams } from '';
import { Observable } from 'rxjs/Observable';
import { FormsCounter } from './../interfaces/forms-counter';
import { FormsAndAgreement } from './../interfaces/forms-and-agreement';
import { AddCustomForm } from './../interfaces/add-custom-form';
import { EditCustomForm } from './../interfaces/edit-custom-form';
import { AddPreStandardForm } from '../interfaces/add-pre-standard-form';
import { PreStandardFormList } from '../interfaces/pre-standard-form-list';
import { HttpService } from './http.service';

@Injectable()
export class FormsAndAgreementService {

  private _url = '/api/ClubRegistrationForm';

  constructor(private http: HttpClient, private httpService: HttpService,) { }

  getFormCounts(clubProgramID: string | number) {
    return this.http.get<FormsCounter>(this._url + '/get-registrationFormCount/' + clubProgramID);
  }

  // TODO: get status code when click on top three box.
  getForms(clubProgramID: string | number, formStatus: number): Observable<FormsAndAgreement[]> {
    return this.http.get<FormsAndAgreement[]>(this._url + '/get-registrationFormsList/' + clubProgramID + '/' + formStatus);
  }

  getFormsDetails(formId: number) {
    return this.http.get<FormsAndAgreement>(this._url + '/get-formDetails/' + formId);
  }

  deleteForm(clubprogramquestionID: string) {
    return this.http.delete(this._url + '/delete-form/' + clubprogramquestionID);
  }

  saveCustomForm(addCustomForm: AddCustomForm) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + '/addCustomForm', addCustomForm, httpOptions);
  }

  editCustomForm(editCustomForm: EditCustomForm) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.put(this._url + '/updateCustomForm', editCustomForm, httpOptions);
  }

  savePreStandardForm(addPreStandardForm: AddPreStandardForm) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + '/addPreStandardForm', addPreStandardForm, httpOptions);
  }

  getPreStandardForm(clubProgramID: number) {
    return this.http.get<PreStandardFormList>(this._url + '/get-standardPreLoadedForm/' + clubProgramID);
  }

  formUpload(fileToUpload: any, fileName: any) {
    let fd = new FormData();
    fd.append("file", fileToUpload);
    fd.append("fileName", fileName);
    return this.http.post(this._url + "/UploadCustomForm", fd);
  }

  uploadSingleFile(playerId: number, file) {
    const data = new FormData();
    data.append('file', file);
    return this.httpService.postRaw('api/ClubParent/UploadSingleFile/' + playerId, data);
  }

  saveForms(addForm) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post('api/ClubParent/addForms/', addForm, httpOptions);
  }

  deleteForms(playerFormID) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.delete(`api/ClubParent/removeForm/${playerFormID}`, httpOptions);
  }

  deleteFormAWS(fileURL: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };

    return this.http.post(this._url + '/DeleteCustomFormAWS', '"' + fileURL + '"', httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/forms-and-agreement.service.ts